/**
 * Created by piotr.pozniak@thebeaverhead.com on 04/10/2023.
 */

const initialState = {
  collection: [],
  locations: [],

  fetch: false,
  fetchError: null,
  fetchSuccess: null,

  page: 1,
  totalRows: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "WIDGET_ITEMS_FETCH":
      return {
        ...state,
        fetch: true,
        fetchSuccess: false,
        fetchError: null,
      };

    case "WIDGET_ITEMS_FETCH_FULFILLED":
      const items = action.preservePreviousItems
        ? state.collection.concat(action.payload.items)
        : action.payload.items;

      return {
        ...state,
        collection: items,
        locations: action.payload.locations,
        page: action.payload.pagination ? action.payload.pagination.page : 0,
        totalRows: action.payload.pagination
          ? action.payload.pagination.count
          : items.length,
        fetch: false,
        fetchSuccess: true,
        fetchError: false,
      };

    case "WIDGET_ITEMS_FETCH_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: true,
        collection: action.preservePreviousItems ? state.collection : [],
      };

    case "FEATURED_WIDGET_ITEMS_FETCH_FULFILLED":
      if (state.collection.length) {
        const featuredCollection = state.collection.map((i) => ({
          ...i,
          is_featured:
            action.payload.items.findIndex((j) => j.id === i.id) >= 0,
        }));

        return {
          ...state,
          collection: featuredCollection,
        };
      }

      return state;

    case "WIDGET_ITEMS_COLLECTION_RESET":
      return {
        ...initialState,
      };

    default:
      return state;
  }

  return state;
}
